import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import i18n from 'config/localization';
import { Image, Menu, Tooltip, UnstyledButton } from '@mantine/core';

import { DE_FLAG, EN_FLAG, SR_FLAG } from 'constants/app';
import classes from './index.module.css';

const data = [
  { key: 'de', label: 'german', image: DE_FLAG },
  { key: 'sr', label: 'serbian', image: SR_FLAG },
  { key: 'en', label: 'english', image: EN_FLAG },
];

const normalizeLang = (lang: string) => lang.split('-')[0];

const LanguagePicker = () => {
  const { t } = useTranslation();

  const [opened, setOpened] = useState(false);
  const [selected, setSelected] = useState(data[0]);

  useEffect(() => {
    const normalizedLang = normalizeLang(i18n.language || 'de');
    const langItem = data.find((l) => l.key === normalizedLang) || data[0];
    setSelected(langItem);
  }, []);

  const sortedData = [
    selected,
    ...data.filter((item) => item.label !== selected.label),
  ];

  const items = sortedData.map((item) => (
    <Tooltip
      label={t(`language.${item.label}`)}
      position={'right'}
      offset={{ mainAxis: 15, crossAxis: 0 }}
      key={item.label}
    >
      <Menu.Item className={classes.item}>
        <Image
          src={item.image}
          className={classes.flag}
          onClick={() => {
            setSelected(item);
            i18n.changeLanguage(item.key).then(() => {
              setSelected(item);
            });
          }}
        />
      </Menu.Item>
    </Tooltip>
  ));

  return (
    <Menu
      offset={0}
      onOpen={() => setOpened(true)}
      onClose={() => setOpened(false)}
    >
      <Menu.Target>
        <Tooltip label={t(`language.${selected.label}`)}>
          <UnstyledButton
            className={classes.control}
            data-expanded={opened || undefined}
          >
            <Image src={selected.image} className={classes.flag} />
          </UnstyledButton>
        </Tooltip>
      </Menu.Target>
      <Menu.Dropdown classNames={{ dropdown: classes.dropdown }}>{items}</Menu.Dropdown>
    </Menu>
  );
}

export default LanguagePicker;